const SET_QUESTIONS_LIST = 'SET_QUESTIONS_LIST';
const SET_QUESTIONS_INFO_LIST = 'SET_QUESTIONS_INFO_LIST';
const SET_COMMON_QUESTIONS_LIST = 'SET_COMMON_QUESTIONS_LIST';
const SET_TOPIC = 'SET_TOPIC';
const SET_QUESTIONS_TOPIC_LIST = 'SET_QUESTIONS_TOPIC_LIST';
const SET_SEARCH_STRING = 'SET_SEARCH_STRING';
const SET_SEARCH_MATCHES = 'SET_SEARCH_MATCHES';
const SET_SEARCH_REQUEST = 'SET_SEARCH_REQUEST';
const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
const SET_ITEM_TO_SCROLL = 'SET_ITEM_TO_SCROLL';
const SET_LOADING_QUESTIONS = 'SET_LOADING_QUESTIONS';

const combineConst = {
    SET_QUESTIONS_LIST,
    SET_QUESTIONS_INFO_LIST,
    SET_COMMON_QUESTIONS_LIST,
    SET_TOPIC,
    SET_QUESTIONS_TOPIC_LIST,
    SET_SEARCH_STRING,
    SET_SEARCH_MATCHES,
    SET_SEARCH_REQUEST,
    SET_SEARCH_RESULTS,
    SET_ITEM_TO_SCROLL,
    SET_LOADING_QUESTIONS
};

export default combineConst;
